import React from 'react';
import Truncate from 'react-truncate';

import { Star, Information2 } from '../common/icons';

const ProductsItem = (props) => {
  const {
    brand,
    link,
    image,
    name,
    rsp,
    featured
  } = props;

  return (
    <div className="carousel-item">
      {link ? (
        <a href={link} className="overlay" target="_blank">
          <div className="brand">{brand}</div>
          <Truncate className="product-name" lines={2} ellipsis={<span>...</span>}>
            {name}
          </Truncate>
          <div>RRP: £{rsp}</div>
          <div className="more-info">More Info</div>
        </a>
      ) : (
        <div className="overlay">
          <div className="brand">{brand}</div>
          <Truncate className="product-name" lines={2} ellipsis={<span>...</span>}>
            {name}
          </Truncate>
          <div>RRP: £{rsp}</div>
        </div>
      )}
      {featured && <div className="featured"><Star height={18} width={18} /></div>}
      <div className="information"><Information2 height={18} width={18} /></div>
      <img src={image} alt={name} />
    </div>
  );
};

export default ProductsItem;



// WEBPACK FOOTER //
// ./src/components/products-list/products-item.jsx